module.exports = __webpack_public_path__ + "static/media/e-com_m2.2f96f13c.png";